import { LogoMark } from "@/components/Logo";
import { scrollToId } from "@/components/Reveal";

const Footer = () => (
  <footer
    data-testid="main-footer"
    className="border-t border-white/8 bg-[#05070B] py-14"
  >
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-12">
      <div className="flex flex-col items-start justify-between gap-10 md:flex-row md:items-center">
        <div>
          <span data-testid="footer-logo" className="inline-flex items-center gap-2.5">
            <LogoMark size={30} />
            <span className="font-display text-lg font-bold tracking-tight text-slate-50">
              Akış
            </span>
          </span>
          <p className="mt-3 max-w-xs text-sm leading-relaxed text-slate-500">
            Gelir, gider, banka ve cari hesap yönetimi. Anlık nakit akışı, tek
            panel.
          </p>
        </div>

        <nav className="flex flex-wrap gap-x-8 gap-y-3 text-sm">
          <button
            data-testid="footer-link-features"
            onClick={() => scrollToId("#ozellikler")}
            className="text-slate-400 transition-colors duration-300 hover:text-emerald-400"
          >
            Özellikler
          </button>
          <button
            data-testid="footer-link-demo"
            onClick={() => scrollToId("#demo")}
            className="text-slate-400 transition-colors duration-300 hover:text-emerald-400"
          >
            Canlı Demo
          </button>
          <span
            data-testid="footer-link-privacy"
            className="cursor-pointer text-slate-400 transition-colors duration-300 hover:text-emerald-400"
          >
            Gizlilik Politikası
          </span>
          <span
            data-testid="footer-link-kvkk"
            className="cursor-pointer text-slate-400 transition-colors duration-300 hover:text-emerald-400"
          >
            KVKK Aydınlatma Metni
          </span>
        </nav>
      </div>

      <div className="mt-12 flex flex-col items-start justify-between gap-3 border-t border-white/6 pt-7 text-xs text-slate-600 sm:flex-row sm:items-center">
        <span>© 2026 Akış Finansal Teknolojiler A.Ş. Tüm hakları saklıdır.</span>
        <span className="flex items-center gap-2">
          <span className="animate-pulse-dot h-1.5 w-1.5 rounded-full bg-emerald-400" />
          Tüm sistemler çalışıyor
        </span>
      </div>
    </div>
  </footer>
);

export default Footer;
